module.exports = __webpack_public_path__ + "static/media/30.4f1951b0.svg";